export const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
  'enrollment.created': 'Matrículas registradas',
  'enrollment.confirmed': 'Matrículas confirmadas',
  'class_teacher.assigned': 'Alocações de professores',
  'profile.updated': 'Atualizações de perfil',
  'grades.published': 'Notas publicadas',
  'report_card.available': 'Boletins disponíveis',
  'attendance.pending': 'Frequência pendente',
  'document.pending_validation': 'Documentos pendentes',
  'guardian_consent.pending': 'Consentimentos pendentes',
};

export const NOTIFICATION_PREFERENCE_TYPES = Object.keys(
  NOTIFICATION_TYPE_LABELS,
) as (keyof typeof NOTIFICATION_TYPE_LABELS)[];

export interface NotificationPreferenceGroup {
  readonly title: string;
  readonly description: string;
  readonly types: readonly (keyof typeof NOTIFICATION_TYPE_LABELS)[];
}

export const NOTIFICATION_PREFERENCE_GROUPS: readonly NotificationPreferenceGroup[] =
  [
    {
      title: 'Matrículas',
      description:
        'Avisos sobre novas matrículas registradas e confirmações de vínculo.',
      types: ['enrollment.created', 'enrollment.confirmed'],
    },
    {
      title: 'Equipe e perfil',
      description:
        'Avisos sobre alocações de professores e atualizações da sua conta.',
      types: ['class_teacher.assigned', 'profile.updated'],
    },
    {
      title: 'Avaliação e frequência',
      description:
        'Avisos sobre notas publicadas, boletins disponíveis e frequência pendente.',
      types: [
        'grades.published',
        'report_card.available',
        'attendance.pending',
      ],
    },
    {
      title: 'Documentação e consentimentos',
      description:
        'Avisos sobre documentos para validar e autorizações pendentes.',
      types: ['document.pending_validation', 'guardian_consent.pending'],
    },
  ];

export function defaultNotificationPreferences(): {
  notificationType: string;
  muted: boolean;
}[] {
  return NOTIFICATION_PREFERENCE_TYPES.map((type) => ({
    notificationType: type,
    muted: false,
  }));
}
